var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pajamas:project",
    clipPath: "url(#clip0_7_89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.875 18.125L4.375 15V4.99997L11.875 1.87497V18.125ZM3.26875 16.57C3.04106 16.475 2.84656 16.3148 2.70976 16.1094C2.57296 15.9041 2.49998 15.6629 2.5 15.4162V4.58372C2.49998 4.33701 2.57296 4.09581 2.70976 3.8905C2.84656 3.68519 3.04106 3.52496 3.26875 3.42997L11.1538 0.143722C11.4387 0.0249637 11.7486 -0.0215885 12.0559 0.00819875C12.3632 0.037986 12.6584 0.143191 12.9152 0.314472C13.1721 0.485754 13.3827 0.717811 13.5283 0.990039C13.6739 1.26227 13.7501 1.56624 13.75 1.87497V2.49997H15.3125C16.52 2.49997 17.5 3.47872 17.5 4.68747V15.3125C17.5 15.8926 17.2695 16.449 16.8593 16.8593C16.4491 17.2695 15.8927 17.5 15.3125 17.5H13.75V18.125C13.7501 18.4337 13.6739 18.7377 13.5283 19.0099C13.3827 19.2821 13.1721 19.5142 12.9152 19.6855C12.6584 19.8568 12.3632 19.962 12.0559 19.9917C11.7486 20.0215 11.4387 19.975 11.1538 19.8562L3.26875 16.57ZM13.75 15.625H15.3125C15.3954 15.625 15.4749 15.592 15.5335 15.5334C15.5921 15.4748 15.625 15.3954 15.625 15.3125V4.68747C15.625 4.60459 15.5921 4.52511 15.5335 4.4665C15.4749 4.4079 15.3954 4.37497 15.3125 4.37497H13.75V15.625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_89"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.cef18938f942bc1938162023b5154647.svg";
export { ForwardRef as ReactComponent };